import { render, staticRenderFns } from "./surgeOrderHis.vue?vue&type=template&id=0ebfca20&scoped=true"
import script from "./surgeOrderHis.vue?vue&type=script&lang=js"
export * from "./surgeOrderHis.vue?vue&type=script&lang=js"
import style0 from "./surgeOrderHis.vue?vue&type=style&index=0&id=0ebfca20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebfca20",
  null
  
)

export default component.exports